import React, { memo } from 'react';
import useAppUpdateCheck from '../../../hooks/useAppUpdateCheck';
import AppUpdatePrompt from './AppUpdatePrompt';

function AppUpdateRoot() {
  const { prompt, dismiss, applyUpdate } = useAppUpdateCheck();

  return (
    <AppUpdatePrompt
      visible={Boolean(prompt)}
      title={prompt ? prompt.title : ''}
      changes={prompt ? prompt.changes : []}
      onUpdate={applyUpdate}
      onDismiss={dismiss}
    />
  );
}

export default memo(AppUpdateRoot);
